import createApiClient from './apiClient';

const authApi = createApiClient(process.env.REACT_APP_ATHENIAN_AUTH_SERVICE_URL);

export const login = (email, password) =>
  authApi.post('/login', { email, password });

export const forgotPassword = (email) =>
  authApi.post('/forgot-password', { email });

export const logout = () =>
  authApi.post('/logout');

export const resetPassword = (token, new_password) =>
  authApi.post('/reset-password', { token, new_password });
